import type { BackendVault } from '@/types'
import type { Subdomain } from '@/types/Subdomain'
import { SubdomainType } from '@/types/Subdomain'

export function isVaultCuratedByProtocol(vault: BackendVault, subdomain: Subdomain) {
  const isProtocol = subdomain.type === SubdomainType.Protocol

  return isProtocol && vault.isFeatured
}
